<style lang="less" scoped>
  @import '../../../assets/colorTheme';

  .top-row{
    margin-bottom: 20px;
    .el-col{
      >*{
        &:first-child{width: 100%;height: 80px;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);}
      }
      .overview-buttons{
        display: flex;
        border: 0;
        .el-button{
          border-width: 0 0 0 1px;
          border-color: #eee;
          &:first-child{border: 0;}
          flex: 1;
          font-size: 18px;
        }
      }
      .el-date-editor.el-range-editor{
        border: 0;
        /deep/.el-input__icon{width: 40px; font-size: 18px;}
        /deep/.el-range-separator{line-height: 75px; font-size: 18px;}
        /deep/.el-range-input{font-size: 18px;}
      }
      .overview-box{
        border-radius: 5px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        >*{flex: 1; &:first-child{text-align: center;}}
        i{
          font-size: 26px;
          width: 50px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          color: white;
          border-radius: 50px;
        }
        &.total i{
          background-color: @mainColor;
          border: 5px solid @mainColor + #574040
        }
        &.percent i{
          background-color: #ff6384;
          border: 5px solid #ffdde4;
        }

        .number{font-size: 30px; color: #555; margin-bottom: 4px;}
        .label{font-size: 14px; color: #888;}
      }
    }
  }
</style>

<template>
  <div v-loading="loading">
    <el-row :gutter="20" class="top-row">
      <el-col :span="8">
        <el-button-group class="overview-buttons">
          <el-button :class="currentSelect==='all'?  'el-button--primary':''" @click="load('all')">全部</el-button>
          <el-button :class="currentSelect==='today'?'el-button--primary':''" @click="load('today')">今天</el-button>
          <el-button :class="currentSelect==='week'? 'el-button--primary':''" @click="load('week')">本周</el-button>
          <el-button :class="currentSelect==='month'?'el-button--primary':''" @click="load('month')">本月</el-button>
        </el-button-group>
      </el-col>
      <el-col :span="8">
        <el-date-picker
          v-model="timeRange"
          value-format="timestamp"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-col>
      <el-col :span="4">
        <div class="overview-box total">
          <div> <i class="el-icon-files"></i> </div>
          <div>
            <div class="number">{{total}}</div>
            <div class="label">总数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="overview-box percent">
          <div> <i class="el-icon-pie-chart"></i> </div>
          <div>
            <div class="number">{{passPercent}}</div>
            <div class="label">通过率</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <charts-view :data-list="chartData"></charts-view>

      <el-row :gutter="15" class="card-row">
        <el-col :span="8" v-for="item in dataList" :key="item.id">
          <one-to-one-card :data="item"></one-to-one-card>
        </el-col>
      </el-row>

      <el-pagination style="text-align: center; "
                     :total="total" :layout="'prev, pager, next, jumper, ->, total'"
                     :current-page="pageForm.page + 1"
                     :page-size="pageForm.size"
                     @current-change="pageChange"
      ></el-pagination>
  </div>
</template>

<script>
  import chartsView from "@/components/charts/index"
  import OneToOneCard from "@/components/1v1card"
  import moment from "moment";

  export default {
    components: {
      OneToOneCard,
      chartsView
    },
    data() {
      return {
        timeRange: '',
        currentSelect: 'all',
        dataList: [],
        statisticsData: {},
        chartData: {},
        total: 0,
        pageForm: {
          page: 0,
          size: 9,
          startTime: 946656000, //2000-01-01
          endTime: moment().valueOf()
        },
        loading: false,
        get passPercent() {
          if(this.statisticsData.total){
            return (this.statisticsData.successCount / this.statisticsData.total * 100).toFixed(2) + '%'
          }

          return '...'
        },
      }
    },
    watch: {
      pageForm: {
        handler(v){
          this.loadRecords()
        },
        deep: true
      },
      timeRange (v) {
        if (!v) {
          if(!this.currentSelect){
            this.currentSelect = 'all'
            this.pageForm.startTime = 946656000 //2000-01-01
            this.pageForm.endTime = moment().valueOf()
          }
        } else {
          this.currentSelect = ''
          let [start, end] = v
          this.pageForm.startTime = start
          this.pageForm.endTime = end
        }
      }
    },
    methods: {
      load(time){
        //all、today、week、month
        this.currentSelect = time;
        this.timeRange = ''
        if (time==='all') {
          this.pageForm.startTime = 946656000 //2000-01-01
        } else if (time === 'today') {
          this.pageForm.startTime = moment().startOf('date').valueOf()
        } else if (time === 'week') {
          this.pageForm.startTime = moment().startOf('week').valueOf()
        } else if (time === 'month') {
          this.pageForm.startTime = moment().startOf('month').valueOf()
        }
        this.pageForm.endTime = moment().valueOf();
      },
      async loadRecords(){
        this.loading = true;

        let res = await this.$request(this.$api.record.list1vs1(this.pageForm));
        this.dataList = res.list;
        for (let e of res.list) {
          if(e.result[0]==='{'){
            e.result = JSON.parse(e.result);
            if(e.result.message){
              e.result = e.result.message
            }else{
              e.matchNumber = Math.round(e.result.match * 100 * 100)/100;
            }
          }
        }
        this.total = res.total;

        this.loading = false;

        let response = await this.$request(this.$api.record.statistics1vs1(this.pageForm));
        this.statisticsData = response;

        //刷新图表
        // if(this.currentSelect === 'all') {
        //   this.chartData = response
        // }
        this.chartData = response

      },
      pageChange(page) {
        this.pageForm.page = page - 1;
      },
    },
    beforeRouteEnter(to, from, next) {
      if(Vue.store.state.me === null) {
        next(vm => {
          vm.$router.push('login')
        })
      } else {
        let _check = Vue.store.state.me.authorities.map(({ authority }) => authority).includes('admin')
        if(_check){
          next()
        }else{
          next(vm => {
            vm.$router.push('/1vs1/detect')
          })
        }
      }
    },
    mounted() {
      this.loadRecords();
    }
  }
</script>
